import classnames from "classnames";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import {
    CategoryFilterOption,
    isFilterSection,
    UniversalFilterSection,
} from "web/types/universal-filters";
import styles from "./chevron-filter-item.css";

interface ChevronFilterItemProps {
    item: UniversalFilterSection | CategoryFilterOption;
    onClick: (item: UniversalFilterSection | CategoryFilterOption) => void;
    large: boolean;
    expanded: boolean;
    subText?: string;
    ariaControls?: string;
}

function ChevronFilterItem({
    ariaControls,
    expanded,
    item,
    large,
    onClick,
    subText,
}: ChevronFilterItemProps): JSX.Element {
    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        onClick(item);
    }
    let href: string;
    let label: string;

    if (isFilterSection(item)) {
        href = "#";
        label = item.title;
    } else {
        href = item.url;
        label = item.label;
    }

    let showRadio = !large;

    return (
        <a
            href={href}
            className={classnames(styles.filterItem, { [styles.largeItem]: large })}
            onClick={handleClick}
            role="button"
            aria-expanded={expanded}
            aria-controls={ariaControls}
        >
            <span className={styles.text}>
                {showRadio ? (
                    <span className={styles.radioButton}>
                        {item.type == "category" && item.checked ? (
                            <SVGIcon name={"round-radiobutton-checked"} />
                        ) : (
                            <SVGIcon name={"round-radiobutton"} />
                        )}
                    </span>
                ) : null}
                <span className={styles.label}>{label}</span>
                {subText && (
                    <span className={classnames(styles.subText, { [styles.hidden]: expanded })}>
                        {subText}
                    </span>
                )}
            </span>
            <SVGIcon
                className={classnames(styles.icon, { [styles.rotate]: expanded })}
                name="round-chevron"
            />
        </a>
    );
}

export default ChevronFilterItem;
